const OrderTypes = {
  SET_TEMP_ORDER: "SET_TEMP_ORDER",
  SET_PICKUP_LOCATION: "SET_PICKUP_LOCATION",
  SET_ITEM_DROP: "SET_ITEM_DROP",
  SET_RE_ROUTING: "SET_RE_ROUTING",
};

export default OrderTypes;
